import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class FinancialFilingQueryCriteriaClass extends BaseCriteriaModel {
  //for header
  name?: Optional<string> = Optional.empty();
  date_start?: Optional<string> = Optional.empty();
  date_end?: Optional<string> = Optional.empty();
  date_filing?: Optional<string> = Optional.empty();
  filing_type?: Optional<string> = Optional.empty();
  filing_code?: Optional<string> = Optional.empty();
  filing_option?: Optional<string> = Optional.empty();
  filing_namespace?: Optional<string> = Optional.empty();

  //for extension
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();

  //for link
  filing_hdr_guid?: Optional<string> = Optional.empty();
  doc_hdr_guid?: Optional<string> = Optional.empty();
  filing_status?: Optional<string> = Optional.empty();

}

export class FinancialFilingCriteriaModelQuery {
  query = '';

  constructor(financialFilingCriteriaModel: FinancialFilingQueryCriteriaClass) {

    if (!financialFilingCriteriaModel) {
      return;
    }

    this.query += financialFilingCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += financialFilingCriteriaModel.date_start.filter(x => x !== '').map(x => '&date_start=' + x).orElse('');
    this.query += financialFilingCriteriaModel.date_end.filter(x => x !== '').map(x => '&date_end=' + x).orElse('');
    this.query += financialFilingCriteriaModel.date_filing.filter(x => x !== '').map(x => '&date_filing=' + x).orElse('');
    this.query += financialFilingCriteriaModel.filing_type.filter(x => x !== '').map(x => '&filing_type=' + x).orElse('');
    this.query += financialFilingCriteriaModel.filing_code.filter(x => x !== '').map(x => '&filing_code=' + x).orElse('');
    this.query += financialFilingCriteriaModel.filing_option.filter(x => x !== '').map(x => '&filing_option=' + x).orElse('');
    this.query += financialFilingCriteriaModel.filing_namespace.filter(x => x !== '').map(x => '&filing_namespace=' + x).orElse('');

    this.query += financialFilingCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += financialFilingCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += financialFilingCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += financialFilingCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += financialFilingCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += financialFilingCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');

    this.query += financialFilingCriteriaModel.filing_hdr_guid.filter(x => x !== '').map(x => '&filing_hdr_guid=' + x).orElse('');
    this.query += financialFilingCriteriaModel.doc_hdr_guid.filter(x => x !== '').map(x => '&doc_hdr_guid=' + x).orElse('');
    this.query += financialFilingCriteriaModel.filing_status.filter(x => x !== '').map(x => '&filing_status=' + x).orElse('');

    this.query += '&status=' + financialFilingCriteriaModel.status;
    this.query += '&orderBy=' + financialFilingCriteriaModel.orderBy;
    this.query += '&order=' + financialFilingCriteriaModel.order;
    this.query += '&offset=' + financialFilingCriteriaModel.offset + '&limit=' + financialFilingCriteriaModel.limit;
  }
}
